<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
    [ngClass]="{'expanded': isHandset$ | async}"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async)">
    <app-profile-logo [small]="true"></app-profile-logo>
    <app-side-menu #sideMenu [open]="isHandset$ | async"></app-side-menu>
    <app-language-selector class="mt-auto"></app-language-selector>
  </mat-sidenav>
  <mat-sidenav #search position="end">
    <app-global-search (close)="search.close()"></app-global-search>
  </mat-sidenav>
  <mat-sidenav-content style="overflow-x: clip;">
    <app-top-toolbar (toggleDrawer)="drawer.toggle()" (toggleSearch)="search.toggle()"></app-top-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
